import { Dispatch } from '@reduxjs/toolkit';
import { notify } from 'front-commons/ds';
import { getUserData, logout } from 'services/customer';
import {
	resetUserIsLoggingOut,
	set2FAExpiration,
	setCustomer,
	setLoading,
	setLogout,
	setProvider,
	setToken,
	setUpdatePartially,
	manageFirstAccess,
	updateCurrentStep,
	setPartnerLabel,
	setDeviceToken,
} from './actions';
import { CustomerDataResponse } from 'services/customer/interfaces';
import { clearFidelity } from 'stores/fidelity/actions';
import { clearCatalog } from 'stores/catalog/actions';
import { setCleanPos } from 'stores/pos/actions';
import { CustomerProvider, HandleGetCustomerDataParams } from './interfaces';
import { insiderDispatcher } from 'services/insider';
import { sendInfosToPartners } from './helpers';
import { setCleanBasket } from 'stores/basket/actions';
import { apm } from '@elastic/apm-rum';
import { clearModal } from 'stores/modal/actions';

export const handleSetLogout =
	(userIsLoggingOut?: boolean): any =>
		async (dispatch: Dispatch, getState: any) => {
			dispatch(setLoading(true));

			try {
				if (getState().customerReducer.token && getState().customerReducer.provider === 'PARCEIRO_HYPERA') await logout();
			} catch {
			} finally {
				dispatch(setLogout(userIsLoggingOut));
				insiderDispatcher.clearUser();
				apm.setUserContext({});
				dispatch(clearFidelity());
				dispatch(clearCatalog());
				dispatch(clearModal());
				dispatch(setCleanPos());
				dispatch(setCleanBasket());
				localStorage.removeItem('searchModal');
				dispatch(setLoading(false)); // must be in last position
			}
		};

export const handleSetLoading = (loading: boolean): any => {
	return (dispatch: Dispatch) => {
		dispatch(setLoading(loading));
	};
};

export const handleResetUserIsLoggingOut = (): any => {
	return (dispatch: Dispatch) => {
		dispatch(resetUserIsLoggingOut());
	};
};

export const handleGetCustomerData = (props?: HandleGetCustomerDataParams): any => {
	return async (dispatch: Dispatch) => {
		if (!props?.ignoreLoading) dispatch(setLoading(true));

		try {
			const response = await getUserData();

			sendInfosToPartners(response);

			return dispatch(setCustomer(response));
		} catch (error) {
			console.log(error);
			notify.negative({
				description: 'Não foi possível buscar informações do usuário! Por favor, faça login novamente!',
			});

			return dispatch(handleSetLogout());
		} finally {
			if (!props?.ignoreLoading) dispatch(setLoading(false));
		}
	};
};

export const handleSetToken = (token: string): any => {
	return (dispatch: Dispatch) => {
		dispatch(setToken(token));
	};
};

export const handleSetProvider = (provider: CustomerProvider): any => {
	return (dispatch: Dispatch) => {
		dispatch(setProvider(provider));
		if (provider.toLowerCase().includes('zeca') || provider.toLowerCase().includes('televendas')) {
			dispatch(setCustomer({} as CustomerDataResponse));
			dispatch(setCleanPos());
			dispatch(clearFidelity());
		}
	};
};

export const handleUpdatePartially = (customerData: Partial<CustomerDataResponse>): any => {
	return (dispatch: Dispatch) => {
		dispatch(setUpdatePartially(customerData));
	};
};

export const handleUpdate2FAExpiration = (timestamp: number): any => {
	return (dispatch: Dispatch) => {
		dispatch(set2FAExpiration(timestamp));
	};
};

export const handleManageFirstAccess = (action: 'ADD' | 'REMOVE' | 'CLEAR', item?: string): any => {
	return (dispatch: Dispatch) => {
		dispatch(manageFirstAccess(action, item));
	};
};

export const handleUpdateCurrentStep = (step: number): any => {
	return (dispatch: Dispatch) => {
		dispatch(updateCurrentStep(step));
	};
};

export const handleSetPartnerLabel = (label: string): any => {
	return (dispatch: Dispatch) => {
		dispatch(setPartnerLabel(label));
	};
};

export const handleSetDeviceToken = (deviceToken?: string): any => {
	return (dispatch: Dispatch) => {
		dispatch(setDeviceToken(deviceToken));
	};
};
